// src/pages/HomePage.js
import React from "react";
import HeaderComponent from "../components/Header/HeaderComponent";
import Encabezado from "../components/Encabezado/Encabezado";
import Curriculum from "../components/Curriculum/Curriculum";
import Proyectos from "../components/Proyectos/Proyectos";
import Presentacion from "../components/Presentacion/Presentacion";
import FooterComponent from "../components/Footer/FooterComponent";


const HomePage = () => {
  return (
    <section className="flex flex-col min-h-screen">
      <HeaderComponent />
      <div className="flex-1 mx-4 mt-8 sm:mx-10 md:mx-20 lg:mx-28 lg:mt-16">
        <Encabezado />
        <Presentacion />
        <Proyectos />
        <Curriculum />
      </div>
      <FooterComponent />
    </section>
  );
};

export default HomePage;
